module.exports = __webpack_public_path__ + "static/media/03C.3533c17e.png";


//////////////////
// WEBPACK FOOTER
// ./src/assets/robots/03C.png
// module id = 278
// module chunks = 0